var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import MaskedInput from 'react-text-mask';
import { InputText } from '..';

var parseMask = function parseMask(mask) {
  var chars = mask.split('');
  var output = chars.map(function (c) {
    switch (c) {
      case 'A':
        return /[a-zA-Z]/;

      case '#':
        return /\d/;

      default:
        return c;
    }
  });
  return output;
};

var InputMask = function InputMask(_a) {
  var mask = _a.mask,
      name = _a.name,
      placeholder = _a.placeholder,
      props = __rest(_a, ["mask", "name", "placeholder"]);

  return React.createElement(MaskedInput, Object.assign({
    mask: parseMask(mask),
    name: name,
    placeholder: placeholder
  }, props, {
    render: function render(ref, props) {
      return React.createElement(InputText, Object.assign({
        inputRef: ref,
        className: "input-text-masked",
        type: "text",
        name: name
      }, props));
    }
  }));
};

export default InputMask;